import { render } from "./WavetoAppSlide.vue?vue&type=template&id=783c5996&scoped=true"
import script from "./WavetoAppSlide.vue?vue&type=script&lang=js"
export * from "./WavetoAppSlide.vue?vue&type=script&lang=js"

import "./WavetoAppSlide.vue?vue&type=style&index=0&id=783c5996&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783c5996"]])

export default __exports__